import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoCotaDistribOrgao({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'visuacotadistriborgao', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoCotaDistribOrgao({ payload }) {
  try {
    const { orga_codigo, params } = payload;

    yield call(api.delete, `visuacotadistriborgao/${orga_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaocotadistriborgao, params } = payload;

    yield call(
      api.post,
      'visuacotadistriborgao',
      operacaocotadistriborgao
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/visuacotadistriborgao');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { orga_codigo } = payload;

    const { data } = yield call(
      api.get,
      `visuacotadistriborgao/${orga_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaocotadistriborgao, params } = payload;

    yield call(
      api.put,
      'visuacotadistriborgao',
      operacaocotadistriborgao
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/visuacotadistriborgao');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'visuacotadistriborgao', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaocotadistriborgao/VISUACOTADISTRIBORGAO_IN_REQUEST',
    requestOperacaoCotaDistribOrgao
  ),
  takeLatest(
    '@operacaocotadistriborgao/DELETE_VISUACOTADISTRIBORGAO',
    deleteOperacaoCotaDistribOrgao
  ),
  takeLatest(
    '@operacaocotadistriborgao/SUCCESS_REMOVE',
    requestOperacaoCotaDistribOrgao
  ),
  takeLatest(
    '@operacaocotadistriborgao/STORE_VISUACOTADISTRIBORGAO',
    store
  ),
  takeLatest(
    '@operacaocotadistriborgao/FIND_VISUACOTADISTRIBORGAO',
    find
  ),
  takeLatest(
    '@operacaocotadistriborgao/UPDATE_VISUACOTADISTRIBORGAO',
    update
  ),
  takeLatest(
    '@operacaocotadistriborgao/RECORD_FILTERING',
    applyedFilters
  ),
]);
